//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-classes */
/* eslint-disable functional/no-this-expressions */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming



export class DeviceSessionWithoutId implements IDeviceSessionWithoutId {
    applicationType!: ApplicationType;
    multiplayerSessionId?: string;

    constructor(data?: IDeviceSessionWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["ApplicationType"];
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
        }
    }

    static fromJS(data: any): DeviceSessionWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSessionWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ApplicationType"] = this.applicationType;
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        return data;
    }
}

export interface IDeviceSessionWithoutId {
    applicationType: ApplicationType;
    multiplayerSessionId?: string;
}

export class DeviceSessionToUpdate implements IDeviceSessionToUpdate {
    multiplayerSessionId?: string;

    constructor(data?: IDeviceSessionToUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
        }
    }

    static fromJS(data: any): DeviceSessionToUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSessionToUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        return data;
    }
}

export interface IDeviceSessionToUpdate {
    multiplayerSessionId?: string;
}

export class SessionUser implements ISessionUser {
    userId!: string;
    state!: UserMultiplayerSessionState;
    userAvailabilityStatus!: UserAvailabilityStatus;
    deviceSessions?: DeviceSession[];

    constructor(data?: ISessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.state = _data["State"];
            this.userAvailabilityStatus = _data["UserAvailabilityStatus"];
            if (Array.isArray(_data["DeviceSessions"])) {
                this.deviceSessions = [] as any;
                for (let item of _data["DeviceSessions"])
                    this.deviceSessions!.push(DeviceSession.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new SessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["State"] = this.state;
        data["UserAvailabilityStatus"] = this.userAvailabilityStatus;
        if (Array.isArray(this.deviceSessions)) {
            data["DeviceSessions"] = [];
            for (let item of this.deviceSessions)
                data["DeviceSessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionUser {
    userId: string;
    state: UserMultiplayerSessionState;
    userAvailabilityStatus: UserAvailabilityStatus;
    deviceSessions?: DeviceSession[];
}

export class DeviceSession implements IDeviceSession {
    multiplayerSessionId?: string;
    deviceSessionId!: string;
    applicationType!: ApplicationType;
    timestamp!: Date;
    userId!: string;
    wentOnlineTime!: Date;

    constructor(data?: IDeviceSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.deviceSessionId = _data["DeviceSessionId"];
            this.applicationType = _data["ApplicationType"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.userId = _data["UserId"];
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceSession {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["DeviceSessionId"] = this.deviceSessionId;
        data["ApplicationType"] = this.applicationType;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["UserId"] = this.userId;
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceSession {
    multiplayerSessionId?: string;
    deviceSessionId: string;
    applicationType: ApplicationType;
    timestamp: Date;
    userId: string;
    wentOnlineTime: Date;
}

export class MultiplayerSessionWithoutId implements IMultiplayerSessionWithoutId {
    /** Title will be empty if you do not get permission to access the multiplayer session */
    title!: string;
    roomMetadataId!: string;
    visibility!: VisibilityType;
    replayId?: string;
    contentVersion?: string;

    constructor(data?: IMultiplayerSessionWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.roomMetadataId = _data["RoomMetadataId"];
            this.visibility = _data["Visibility"];
            this.replayId = _data["ReplayId"];
            this.contentVersion = _data["ContentVersion"];
        }
    }

    static fromJS(data: any): MultiplayerSessionWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["RoomMetadataId"] = this.roomMetadataId;
        data["Visibility"] = this.visibility;
        data["ReplayId"] = this.replayId;
        data["ContentVersion"] = this.contentVersion;
        return data;
    }
}

export interface IMultiplayerSessionWithoutId {
    /** Title will be empty if you do not get permission to access the multiplayer session */
    title: string;
    roomMetadataId: string;
    visibility: VisibilityType;
    replayId?: string;
    contentVersion?: string;
}

export class MultiplayerSessionInvitation implements IMultiplayerSessionInvitation {
    multiplayerSessionId!: string;
    inviterUserId?: string;
    inviteeUserId!: string;
    invitationStatus!: InvitationStatus;

    constructor(data?: IMultiplayerSessionInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.inviterUserId = _data["InviterUserId"];
            this.inviteeUserId = _data["InviteeUserId"];
            this.invitationStatus = _data["InvitationStatus"];
        }
    }

    static fromJS(data: any): MultiplayerSessionInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["InviterUserId"] = this.inviterUserId;
        data["InviteeUserId"] = this.inviteeUserId;
        data["InvitationStatus"] = this.invitationStatus;
        return data;
    }
}

export interface IMultiplayerSessionInvitation {
    multiplayerSessionId: string;
    inviterUserId?: string;
    inviteeUserId: string;
    invitationStatus: InvitationStatus;
}

export class MultiplayerSession extends MultiplayerSessionWithoutId implements IMultiplayerSession {
    multiplayerSessionId!: string;
    creationDate!: Date;
    visibility!: VisibilityType;
    isRecordingReplay!: boolean;
    currentPlayers!: number;
    /** Server Endpoint will be empty if you do not get permission to access the multiplayer session */
    serverEndpoint?: string;
    creatorUserId!: string;
    roomMetadataId?: string;
    contentVersion!: string;
    region!: string;

    constructor(data?: IMultiplayerSession) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.creationDate = _data["CreationDate"] ? new Date(_data["CreationDate"].toString()) : <any>undefined;
            this.visibility = _data["Visibility"];
            this.isRecordingReplay = _data["IsRecordingReplay"];
            this.currentPlayers = _data["CurrentPlayers"];
            this.serverEndpoint = _data["ServerEndpoint"];
            this.creatorUserId = _data["CreatorUserId"];
            this.roomMetadataId = _data["RoomMetadataId"];
            this.contentVersion = _data["ContentVersion"];
            this.region = _data["Region"];
        }
    }

    static fromJS(data: any): MultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["CreationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["Visibility"] = this.visibility;
        data["IsRecordingReplay"] = this.isRecordingReplay;
        data["CurrentPlayers"] = this.currentPlayers;
        data["ServerEndpoint"] = this.serverEndpoint;
        data["CreatorUserId"] = this.creatorUserId;
        data["RoomMetadataId"] = this.roomMetadataId;
        data["ContentVersion"] = this.contentVersion;
        data["Region"] = this.region;
        super.toJSON(data);
        return data;
    }
}

export interface IMultiplayerSession extends IMultiplayerSessionWithoutId {
    multiplayerSessionId: string;
    creationDate: Date;
    visibility: VisibilityType;
    isRecordingReplay: boolean;
    currentPlayers: number;
    /** Server Endpoint will be empty if you do not get permission to access the multiplayer session */
    serverEndpoint?: string;
    creatorUserId: string;
    roomMetadataId?: string;
    contentVersion: string;
    region: string;
}

export class PrivateMultiplayerSession implements IPrivateMultiplayerSession {
    multiplayerSessionId!: string;
    roomMetaDataId!: string;

    constructor(data?: IPrivateMultiplayerSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.roomMetaDataId = _data["RoomMetaDataId"];
        }
    }

    static fromJS(data: any): PrivateMultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateMultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["RoomMetaDataId"] = this.roomMetaDataId;
        return data;
    }
}

export interface IPrivateMultiplayerSession {
    multiplayerSessionId: string;
    roomMetaDataId: string;
}

export class JoinMultiplayerSession extends MultiplayerSession implements IJoinMultiplayerSession {
    serverEndpoint?: string;
    accessTicket?: string;

    [key: string]: any;

    constructor(data?: IJoinMultiplayerSession) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.serverEndpoint = _data["ServerEndpoint"];
            this.accessTicket = _data["AccessTicket"];
        }
    }

    static fromJS(data: any): JoinMultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new JoinMultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ServerEndpoint"] = this.serverEndpoint;
        data["AccessTicket"] = this.accessTicket;
        super.toJSON(data);
        return data;
    }
}

export interface IJoinMultiplayerSession extends IMultiplayerSession {
    serverEndpoint?: string;
    accessTicket?: string;

    [key: string]: any;
}

export class MultiplayerSessionUser implements IMultiplayerSessionUser {
    userId!: string;
    companyId!: string;
    userName!: string;
    accessTicket!: string;

    constructor(data?: IMultiplayerSessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.companyId = _data["CompanyId"];
            this.userName = _data["UserName"];
            this.accessTicket = _data["AccessTicket"];
        }
    }

    static fromJS(data: any): MultiplayerSessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CompanyId"] = this.companyId;
        data["UserName"] = this.userName;
        data["AccessTicket"] = this.accessTicket;
        return data;
    }
}

export interface IMultiplayerSessionUser {
    userId: string;
    companyId: string;
    userName: string;
    accessTicket: string;
}

export enum UserAvailabilityStatus {
    Offline = "Offline",
    Online = "Online",
    Away = "Away",
    Busy = "Busy",
}

export enum VisibilityType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export enum ApplicationType {
    DesktopApp = "DesktopApp",
    VR = "VR",
    AR = "AR",
}

export enum UserOnlineStatus {
    Normal = "Normal",
    Busy = "Busy",
    Away = "Away",
}

export enum UserMultiplayerSessionState {
    Joining = "Joining",
    InSession = "InSession",
    Leaving = "Leaving",
}

export enum InvitationStatus {
    Pending = "Pending",
    Accepted = "Accepted",
    Declined = "Declined",
}